import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { Button, ButtonLink } from 'components'
import { useBreakpoint } from 'modules/breakpoint'
import { SNotFound } from './NotFound.styled'

function NotFound() {
  const history = useHistory()
  const breakpoint = useBreakpoint()

  const { formatMessage } = useIntl()

  const goHome = () => history.replace('/')

  return (
    <SNotFound>
      <div className="content">
        <p>Error 404</p>
        <p className="message">{formatMessage({ id: '404.notFound' })}</p>
        <Button onClick={goHome}>
          {formatMessage({ id: '404.homePage' })}
        </Button>
      </div>
      <div className="background">
        {!breakpoint.lg ? (
          <svg
            viewBox="0 0 1680 899"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path id="prefix__a" d="M0 0h15.9v15.9H0z" />
              <path id="prefix__c" d="M0 0h15.9v15.9H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path fill="#292929" d="M0 0h1680v899H0z" />
              <g transform="translate(-149 70.7)">
                <circle
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  cx={989.9}
                  cy={380.4}
                  r={151.5}
                />
                <path
                  d="M1622.6 335.7c-149.4 72.4-457.8 67-541.7 73.6-83.8 6.7-266.2 44-266.2 44s-107.6 23.1-179.6-6.3c-148.7-80-291.3 35.7-500.5 46.3-55.6.8-134.2-10-134.2-10v154.1s150 30.3 452.2-37c83.2-16.1 189-26 265.3-31.6h1202.5V217.5c-79.3 0-147.3 45.2-297.8 118.2z"
                  fill="#4B4B4B"
                  fillRule="nonzero"
                />
                <path
                  d="M1273.3 436v56.8h-54.5V436h-121l118.3-196.4h57.2v150.8h32.1V436h-32.1zm-54.5-45.7v-78.9l-47.2 78.9h47.2zM783 436v56.8h-54.5V436h-121l118.3-196.4H783v150.8h32.1V436H783zm-54.5-45.7v-78.9l-47.2 78.9h47.2z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M1596.5 348.5c-149.4 72.4-402.7 165.9-544.7 165.5-142-.4-216.2-24.6-287.6-34-71.4-9.4-197.4-5.5-328.5-22.8-131.2-17.3-205.1 66.7-301.5 72.8C37.8 536.1 0 520 0 520v174.2s315.8-26.6 513.8-40.6c198-14 646-6 897-1s509.2 63 509.2 63V264.2s-173.1 11.4-323.5 84.3z"
                  fill="#6A6A6A"
                  fillRule="nonzero"
                />
                <path
                  d="M1829 449.14c-75.9-13.979-188.794-22.845-358.5 6.96-279 49-280 100-723 79-255.684-12.12-467.147 20.96-598.5 49.5-96.23 20.908 0 1.96 0 1.96V828.3h1680V449.14z"
                  fill="#7F7F7F"
                  fillRule="nonzero"
                />
                <path
                  fill="#FFE4FD"
                  fillRule="nonzero"
                  d="M950.3 507.7H1075v66.9H950.3z"
                />
                <path
                  fill="#FFE4FD"
                  fillRule="nonzero"
                  d="M888 465.8h79.3v108.8H888z"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M897 473.7h15.9v15.9H897z"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M919.7 473.7h15.9v15.9h-15.9z"
                />
                <path
                  d="M942.4 473.7h15.9v15.9h-15.9v-15.9zM897 496.4h15.9v15.9H897v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M942.4 496.4h15.9v15.9h-15.9z"
                />
                <path
                  d="M897 519.1h15.9V535H897v-15.9zm45.4 0h15.9V535h-15.9v-15.9zm32.8 1.1h15.9v15.9h-15.9v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M1020.6 520.2h15.9v15.9h-15.9z"
                />
                <path
                  d="M975.2 542.9h15.9v15.9h-15.9v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M1043.2 520.2h15.9v15.9h-15.9z"
                />
                <path
                  d="M1043.2 542.9h15.9v15.9h-15.9v-15.9zM897 541.7h15.9v15.9H897v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9zm22.7 0h15.9v15.9h-15.9v-15.9z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <g transform="translate(897 519.1)">
                  <mask id="prefix__b" fill="#fff">
                    <use xlinkHref="#prefix__a" />
                  </mask>
                  <use fill="#FDBAF9" xlinkHref="#prefix__a" />
                  <path
                    d="M-1.1-1.2L17 17m1.2-19.3L-1.1 17"
                    stroke="#FC86F6"
                    mask="url(#prefix__b)"
                  />
                </g>
                <path
                  fill="#5684E4"
                  fillRule="nonzero"
                  d="M919.7 519.1h15.9V535h-15.9z"
                />
                <g transform="translate(919.7 519.1)">
                  <mask id="prefix__d" fill="#fff">
                    <use xlinkHref="#prefix__c" />
                  </mask>
                  <use fill="#FDBAF9" xlinkHref="#prefix__c" />
                  <path
                    d="M-1.1-1.2L17 17m1.1-19.3L-1.1 17"
                    stroke="#FC86F6"
                    mask="url(#prefix__d)"
                  />
                </g>
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M912.9 512.3H905l3.4-15.9h4.5"
                />
                <path
                  fill="#FFE4FD"
                  fillRule="nonzero"
                  d="M675.667 485.633v101h-128.4v-101z"
                />
                <path
                  d="M665.538 497.19v25.6h-20.2v-25.6h20.2zm.032 36.633v25.6h-20.2v-25.6h20.2z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M665.53 573.482v13.1h-20.2v-13.1z"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M636.68 497.148v25.6h-20.2v-25.6z"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M607.816 573.496v13.1h-20.2v-13.1z"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M578.967 497.162v25.6h-20.2v-25.6z"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M579 533.795v25.6h-20.2v-25.6zm-.04 39.758v13.1h-20.202v-13.1h20.202zm57.856-.057v13.1h-20.2v-13.1h20.2z"
                />
                <path
                  fill="#FFF"
                  fillRule="nonzero"
                  d="M433.4 533.5h76.8v53.1h-76.8z"
                />
                <path
                  d="M426 524.6h93v8.9h-93v-8.9zm25.1 36.9H491v3h-39.9v-3z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M442.2 537.9h59v23.6h-59v-23.6zm5.2 0v23.6m4.4-23.6v23.6m4.4-23.6v23.6m4.5-23.6v23.6m4.4-23.6v23.6m4.4-23.6v23.6m4.5-23.6v23.6m4.4-23.6v23.6m4.4-23.6v23.6m4.4-23.6v23.6m4.5-23.6v23.6m4.4-23.6v23.6m-53.6-19.2H501m-58.5 4.8H501m-58.5 4.7H501m-58.5 4.8H501"
                  stroke="#FC86F6"
                />
                <path
                  fill="#E8EEF6"
                  fillRule="nonzero"
                  d="M1518.5 487.1h-127"
                />
                <path
                  d="M329.1 487.1l-11.3-34.3-11.3 34.3m-2.8 6.7l-11.4-34.7-11.4 34.7"
                  fill="#FFE4FD"
                  fillRule="nonzero"
                />
                <path
                  d="M297 507.8l-13.5-41.2-13.5 41.2m72.7-5.7l-13.3-40.7-13.4 40.7"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M277.2 515.2l-13.5-41.3-13.6 41.3"
                />
                <path
                  fill="#FFE4FD"
                  fillRule="nonzero"
                  d="M352.5 479.6l-7.7-23.5-7.7 23.5"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M361.6 489.4l-8.8-26.8-8.8 26.8"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M326.8 507.8L318 481l-8.8 26.8"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M314.8 511.8l-11.2-34.1-11.2 34.1"
                />
                <path
                  d="M390.6 462.1l11.3-34.3 11.3 34.3m.8 9.7l9.4-28.7 9.4 28.7"
                  fill="#FFE4FD"
                  fillRule="nonzero"
                />
                <path
                  d="M421.1 483.3l10.1-30.7 10.1 30.7m-60.5-9.4l9.5-28.9 9.5 28.9"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M432.8 484.2l11.3-34.3 11.2 34.3"
                />
                <path
                  fill="#FFE4FD"
                  fillRule="nonzero"
                  d="M367.2 465.6l7.7-23.5 7.7 23.5"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M358.1 475.4l8.8-26.8 8.8 26.8"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M392.9 485.8l8.8-26.8 8.8 26.8"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M401.9 489.8l11.2-34.1 11.2 34.1m183.524 7.305v25.6h-20.2v-25.6h20.2zm28.87 36.857v25.6h-20.2v-25.6h20.2z"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M607.838 533.92v25.6h-20.2v-25.6z"
                />
                <path
                  d="M557.8 555.4v-4.8l23.1 3 .1 4.8m-24.2-9v-4.8h23.1l.1 4.8m-22.2-7v-3.8l23.1-3 .1 3.8m28 14.2v4.8l-23.2-3v-4.8m23.2-15v4.8h-23.2v-4.8m23.2 6v4.5l-23.2 3.5v-4.5"
                  fill="#F34BED"
                  fillRule="nonzero"
                />
                <path
                  fill="#FFF"
                  fillRule="nonzero"
                  d="M1373 584.6h-73v-46l37-19 36 19"
                />
                <path
                  stroke="#FDBAF9"
                  strokeWidth={7}
                  d="M1296 541.6l41-22 41 22"
                />
                <path
                  d="M1334 540.2v-6.6c0-1.7 1.3-3 3-3 1.6 0 3 1.3 3 3v6.6m-29 8.4h17.2v19H1311v-19zm33.8 0h17.2v19h-17.2v-19z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  d="M1638.1 346.1l-11.3-34.3-11.3 34.3m-2.8 6.7l-11.4-34.7-11.4 34.7"
                  fill="#FFE4FD"
                  fillRule="nonzero"
                />
                <path
                  d="M1606 366.8l-13.5-41.2-13.5 41.2m72.7-5.7l-13.3-40.7-13.4 40.7"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M1586.2 374.2l-13.5-41.3-13.6 41.3m102.4-35.6l-7.7-23.5-7.7 23.5"
                />
                <path
                  d="M1670.6 348.4l-8.8-26.8-8.8 26.8m-17.2 18.4L1627 340l-8.8 26.8"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  fill="#FC86F6"
                  fillRule="nonzero"
                  d="M1623.8 370.8l-11.2-34.1-11.2 34.1"
                />
                <path
                  d="M548 332.4c-1.5 1.1-133 2.5-133 0s18.1-3.6 27.5-7.5c9.5-3.9 19.3-6.6 25.7-3.8 6.4 2.8 14.1 6.6 20.5 3.8s11.3-7.5 19.8-6.6c8.5.9 8.5 3.8 15.5 6.6 7.1 2.8 8.5-5.7 12.7-3.8 4.2 1.9 12.8 10.2 11.3 11.3zm671-50.5c0 1.6-182 3.6-182 0s28.3-3.8 38.5-7.9c10.2-4.1 23.2-6.7 31.2-3.2s29.8 5.3 37.7 1.7c8-3.5 14.2-9.4 24.8-8.2 10.6 1.2 10.7 4.7 19.5 8.2 8.9 3.5 10.7-1.1 16 1.2 5.4 2.4 14.3 6.6 14.3 8.2z"
                  fill="#7F7F7F"
                  fillRule="nonzero"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M1719 380.4h-43.6v-27.5l22.1-11.3 21.5 11.3"
                />
                <path
                  stroke="#FC86F6"
                  strokeWidth={4}
                  d="M1673 354.7l24.5-13.1 24.5 13.1"
                />
                <path
                  d="M1695.7 353.9V350c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v3.9"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M1681.9 358.9h10.3v11.4h-10.3v-11.4zm20.2 0h10.3v11.4h-10.3v-11.4zM1215 584.6s-65-17-106-17-243 5-278 6-70 11-70 11h454zm-480 9s-78.2-14-127.1-10.5c-48.9 3.5-181.9 2.5-203.9 1.5s-112 10-112 10l443-1zm719-10c-27-4-62-1-110-1s-74 5-99 5-43 4-43 4h286s-7-4-34-8z"
                  fill="#6A6A6A"
                  fillRule="nonzero"
                />
                <path
                  fill="#FDBAF9"
                  fillRule="nonzero"
                  d="M1195.5 546.8h2.1v58.8h-2.1z"
                />
                <path
                  d="M1226.3 569.5l-55.2 3.2-.8-14.9 55.2-3.1 7.5 7m-56.1-11.6l44.8 1.3.1-14.9-44.7-1.3-7.2 7.4"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  d="M1180.2 564.9c0 .3.3.6.7.6.4 0 .7-.2.7-.5 0-.2-.1-.4-.6-.5l-.6-.1c-1.1-.3-1.3-.9-1.3-1.3 0-.8.7-1.4 1.6-1.5.9 0 1.6.5 1.6 1.4h-1c0-.3-.2-.5-.6-.5-.4 0-.6.2-.6.5 0 .1.1.4.5.5l.6.2c1.2.3 1.3.9 1.3 1.4 0 .9-.8 1.4-1.7 1.4-1 0-1.7-.6-1.8-1.4l1.2-.2zm2.9-.3c0-1 .7-1.7 1.6-1.7.9 0 1.7.6 1.7 1.6s-.7 1.7-1.6 1.7c-.9 0-1.6-.6-1.7-1.6zm2.4-.1c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4.1.7-.2.7-.7zm2.7 1.6h-1l-.1-5h1l.1 2.6.7-.9h1.2l-1.3 1.5 1.7 1.8h-1.2l-1.1-1.2v1.2zm2.2-1.7c0-1 .7-1.7 1.6-1.7.9 0 1.7.6 1.7 1.6s-.7 1.7-1.6 1.7c-.9.1-1.7-.6-1.7-1.6zm2.4-.1c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4.1.7-.2.7-.7zm2.8-1.6l.6-.4v.7l-.6.4.1 2.6h-1v-2l-.6.4v-.7l.6-.4-.1-2.4h1v1.8zm2.5 3.2c-.9 0-1.7-.6-1.7-1.6s.7-1.7 1.6-1.7c.9 0 1.7.6 1.7 1.6.1 1-.7 1.7-1.6 1.7zm0-1c.4 0 .7-.3.7-.8 0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 .6.3.9.7.8zm.2-4l-.7 1.2h.7l1-1.2h-1zm5.8 4.8h-.8l-.7-2-.6 2.1h-.8l-1.2-3.2h1l.6 1.9.5-1.9h.8l.6 1.9.5-1.9h1l-.9 3.1zm3.1-4.9h2c1.1 0 1.6.7 1.6 1.5s-.4 1.6-1.5 1.6h-.9v1.6h-1l-.2-4.7zm1.1.9v1.3h.9c.4 0 .6-.4.6-.7 0-.3-.2-.7-.6-.7l-.9.1zm2.8 2.2c0-1 .7-1.7 1.6-1.7.9 0 1.7.6 1.7 1.6s-.7 1.7-1.6 1.7c-.9 0-1.7-.6-1.7-1.6zm2.4-.1c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 .4.3.7.7.7.4.1.7-.2.7-.7zm4 1.5v-.4c-.2.3-.5.5-.9.5-.8 0-1.6-.6-1.6-1.6s.7-1.7 1.5-1.7c.4 0 .8.1 1 .4l-.1-2.1h1l.1 5-1-.1zm-.8-2.3c-.4 0-.7.3-.7.8s.4.8.8.8.7-.3.7-.8c-.1-.6-.4-.8-.8-.8zm3.5-2.7l.1 5h-1l-.1-5h1zm1.5 3.8c.3 0 .6.2.6.6 0 .3-.3.6-.6.6s-.6-.2-.6-.6c0-.3.2-.5.6-.6zm-31.2-23.8h1.2l-1.9 5h-.8l-.6-2.7-.8 2.6h-.9l-1.6-5.1h1.2l.9 3.2c.2-.8.5-1.6.7-2.5h.9l.6 2.5 1.1-3zm2.2-.2c.3 0 .6.3.6.6s-.3.6-.6.6-.6-.3-.6-.6c-.1-.3.2-.6.6-.6zm.3 5.3h-1l.1-3.4h1l-.1 3.4zm3.1-3.3v.8h-.7l-.1 2.6h-1l.1-2.6h-.6v-.8h.6v-1.3h1v1.3h.7zm1.5 3.5h-1l.1-5.3h1l-.1 2.8.8-.9h1.3l-1.5 1.5 1.7 2h-1.3l-1.1-1.4.1 1.3zm2.5-1.7c0-1.1.9-1.8 1.8-1.7 1 0 1.8.7 1.7 1.8 0 1.1-.9 1.8-1.8 1.7-.9 0-1.7-.7-1.7-1.8zm2.6.1c0-.5-.3-.8-.8-.8-.4 0-.8.3-.8.8s.3.8.7.8c.5 0 .8-.3.9-.8zm5.4 1.9h-.9l-.6-2.2-.7 2.2h-.9l-1.1-3.5h1.1l.6 2.1.7-2h.9l.5 2.1.7-2h1.1l-1.4 3.3zm1.6-1.7c0-1.1.9-1.8 1.8-1.7 1 0 1.8.7 1.7 1.8-.1 1.1-.9 1.8-1.8 1.7-1 0-1.8-.7-1.7-1.8zm2.5 0c0-.5-.3-.8-.8-.8-.4 0-.8.3-.8.8s.3.8.7.8c.6 0 .9-.3.9-.8z"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  d="M888 657.6s-76-4-95-8-117 6-163 10 258-2 258-2zm774-24h-366s182-14 205-15 82 8 161 15z"
                  fill="#6A6A6A"
                  fillRule="nonzero"
                />
                <path
                  d="M545 481.6h133v4H545v-4zm533.8 26.1H967.3v-6.4l111.5 5m-107.3-40.5h-89v-1.9l44.5-7 44.5 7"
                  fill="#FDBAF9"
                  fillRule="nonzero"
                />
                <path
                  d="M1488 358.4h22.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8H1488c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8zm-213.8 0h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-38.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <circle
                  fill="#00D861"
                  fillRule="nonzero"
                  cx={1248.1}
                  cy={352.6}
                  r={5.8}
                />
                <path
                  d="M1375.3 358.4h86.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-86.7c-3.2 0-5.8 2.6-5.8 5.8-.1 3.2 2.5 5.8 5.8 5.8z"
                  fill="#0E65E5"
                  fillRule="nonzero"
                />
                <path
                  d="M1338.9 358.4h10.3c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-10.3c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M595.6 383.6h58.5c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-58.5c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8z"
                  fill="#00D861"
                  fillRule="nonzero"
                />
                <path
                  d="M530.9 383.6h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-38.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <circle
                  fill="#0E65E5"
                  fillRule="nonzero"
                  cx={504.8}
                  cy={377.7}
                  r={5.8}
                />
                <path
                  d="M441.8 383.6h36.9c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-36.9c-3.2 0-5.8 2.6-5.8 5.8-.1 3.1 2.5 5.8 5.8 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M912.5 334.9h75.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-75.1c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#1ED760"
                  fillRule="nonzero"
                />
                <path
                  d="M821.6 334.9h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-38.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <circle
                  fill="#0E65E5"
                  fillRule="nonzero"
                  cx={886.4}
                  cy={329.1}
                  r={5.8}
                />
                <path
                  d="M1635 518.2h22.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8H1635c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#00D861"
                  fillRule="nonzero"
                />
                <path
                  d="M1437.8 518.2h22.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-22.1c-3.2 0-5.8 2.6-5.8 5.8-.1 3.2 2.5 5.8 5.8 5.8z"
                  fill="#0E65E5"
                  fillRule="nonzero"
                />
                <path
                  d="M1522.3 518.2h86.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-86.7c-3.2 0-5.8 2.6-5.8 5.8-.1 3.2 2.5 5.8 5.8 5.8z"
                  fill="#093272"
                  fillRule="nonzero"
                />
                <path
                  d="M1485.9 518.2h10.3c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-10.3c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M784 627.5h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8H784c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <circle
                  fill="#0E65E5"
                  fillRule="nonzero"
                  cx={757.9}
                  cy={621.6}
                  r={5.8}
                />
                <path
                  d="M885.1 627.5h86.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-86.7c-3.2 0-5.8 2.6-5.8 5.8-.1 3.1 2.5 5.8 5.8 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M848.7 627.5H859c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-10.3c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8zM424.4 156.3h22.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-22.1c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#00D861"
                  fillRule="nonzero"
                />
                <path
                  d="M311.7 156.3h86.6c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-86.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.9 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M275.3 156.3h10.3c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-10.3c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8z"
                  fill="#0E65E5"
                  fillRule="nonzero"
                />
                <path
                  d="M1349.8 25.2h-38.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <path
                  d="M1448 25.2h-72.1c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8h72.1c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8zm50.9 0H1474c-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8h24.9c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <path
                  d="M1501.6 11.7h58.5c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-58.5c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8z"
                  fill="#1ED760"
                  fillRule="nonzero"
                />
                <path
                  d="M1436.9 11.7h38.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-38.7c-3.2 0-5.8 2.6-5.8 5.8 0 3.1 2.6 5.8 5.8 5.8z"
                  fill="#FC86F6"
                  fillRule="nonzero"
                />
                <circle
                  fill="#093272"
                  fillRule="nonzero"
                  cx={1410.8}
                  cy={5.8}
                  r={5.8}
                />
                <path
                  d="M429.6 11.9h28.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.8-5.8-5.8h-28.7c-3.2 0-5.8 2.6-5.8 5.8-.1 3.2 2.5 5.8 5.8 5.8z"
                  fill="#18E5EF"
                  fillRule="nonzero"
                />
                <circle
                  fill="#FC86F6"
                  fillRule="nonzero"
                  cx={403.5}
                  cy={6.1}
                  r={5.8}
                />
              </g>
            </g>
          </svg>
        ) : (
          <svg viewBox="0 0 321 221" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path fill="#292929" d="M0 0h320v221H0z" />
              <ellipse
                fill="#FDBAF9"
                fillRule="nonzero"
                cx={166.1}
                cy={78.537}
                rx={53.4}
                ry={53.286}
              />
              <path
                d="M320.2 135.016H113.1c-18.4 1.597-44 4.291-64 8.781-18.6 4.79-34.9 7.784-48.7 9.58v-30.635c34.4-6.386 59.2-17.662 92.8-9.28 17.4 8.083 43.4 1.697 43.4 1.697s44-10.278 64.3-12.174c18.3-1.697 81.1-3.992 119.5-19.26l-.2 51.291z"
                fill="#4B4B4B"
                fillRule="nonzero"
              />
              <path
                d="M279.4 103.683v21.255H259v-21.255h-45.4L258 30.14h21.5v56.48h12v17.063h-12.1zM259 86.62V57.082L241.3 86.62H259zM95.5 103.683v21.255H75.1v-21.255H29.7L74.1 30.24h21.5v56.48h12v17.063H95.5v-.1zM75.1 86.62V57.082L57.4 86.62h17.7z"
                fill="#FC86F6"
                fillRule="nonzero"
              />
              <path
                d="M0 171.638c21.4-1.896 44.8-3.792 63.8-5.289 47.7-3.692 155.7-1.596 216.2-.299 13.6.3 27.2 1.297 40.3 2.694V88.116l-1.5.599c-37.7 15.367-91 41.112-125.3 41.013-34.2-.1-52.1-.5-69.3-2.894-17.2-2.495-47.6-1.397-79.2-5.988-18.3-2.594-32 3.693-44.8 9.78L0 171.638z"
                fill="#6A6A6A"
                fillRule="nonzero"
              />
              <path
                d="M319.9 221H0v-78.1c30.8-7.285 72.2-12.973 120.4-9.78 106.5 7.085 106.8-10.078 173.9-26.543 9.2-2.295 17.8-3.792 26-4.79"
                fill="#7F7F7F"
                fillRule="nonzero"
              />
              <path
                fill="#FFE4FD"
                fillRule="nonzero"
                d="M175.3 116.755h46.8v25.047h-46.8z"
              />
              <path
                fill="#FFE4FD"
                fillRule="nonzero"
                d="M151.9 101.089h29.8v40.713h-29.8z"
              />
              <path
                fill="#FDBAF9"
                fillRule="nonzero"
                d="M155.3 104.082h6v5.987h-6z"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M163.8 104.082h6v5.987h-6z"
              />
              <path
                d="M172.3 104.082h6v5.987h-6v-5.987zm-17 8.482h6v5.987h-6v-5.987zm8.5 0h6v5.987h-6v-5.987z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M172.3 112.564h6v5.987h-6z"
              />
              <path
                d="M155.3 121.046h6v5.987h-6v-5.987zm17 0h6v5.987h-6v-5.987zm12.4.4h6v5.986h-6v-5.987zm8.5 0h6v5.986h-6v-5.987z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M201.7 121.445h6v5.987h-6z"
              />
              <path
                d="M184.7 129.927h6v5.987h-6v-5.987zm8.5 0h6v5.987h-6v-5.987zm8.5 0h6v5.987h-6v-5.987z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M210.2 121.445h6v5.987h-6z"
              />
              <path
                d="M210.2 129.927h6v5.987h-6v-5.987zm-54.9-.4h6v5.988h-6v-5.987zm8.5 0h6v5.988h-6v-5.987zm8.5 0h6v5.988h-6v-5.987zm-8.5-8.481h6v5.987h-6zm-2.5-2.594h-3l1.3-5.888h1.7"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FFE4FD"
                fillRule="nonzero"
                d="M105.3 117.553v37.82H57.1v-37.82z"
              />
              <path
                d="M101.5 121.844v9.58h-7.6v-9.58h7.6zm.1 13.671v9.58H94v-9.58h7.6z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M101.5 150.483v4.89h-7.6v-4.89z"
              />
              <path
                fill="#FDBAF9"
                fillRule="nonzero"
                d="M90.7 121.844v9.58h-7.6v-9.58z"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M79.9 150.383v4.89h-7.6v-4.89z"
              />
              <path
                fill="#FDBAF9"
                fillRule="nonzero"
                d="M69 121.844v9.58h-7.6v-9.58z"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M69.1 135.515v9.58h-7.6v-9.58zm-.1 14.868v4.89h-7.6v-4.89H69zm21.7 0v4.89h-7.6v-4.89h7.6z"
              />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M14.4 135.415h28.8v19.858H14.4z"
              />
              <path
                d="M11.6 132.122h34.9v3.293H11.6v-3.293zm9.4 13.771h15v1.098H21v-1.098z"
                fill="#FC86F6"
                fillRule="nonzero"
              />
              <path
                d="M17.7 137.112h22.2v8.88H17.7v-8.88zm2 0v8.781m1.6-8.781v8.781m1.7-8.781v8.781m1.6-8.781v8.781m1.7-8.781v8.781m1.7-8.781v8.781m1.6-8.781v8.781m1.7-8.781v8.781m1.6-8.781v8.781m1.7-8.781v8.781m1.7-8.781v8.781m1.6-8.781v8.781m-20.1-7.185h22m-22 1.797h22m-22 1.796h22m-22 1.796h22"
                stroke="#FC86F6"
              />
              <path
                d="M79.9 121.844v9.58h-7.6v-9.58h7.6zm10.8 13.771v9.58h-7.6v-9.58h7.6z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                fill="#FC86F6"
                fillRule="nonzero"
                d="M79.9 135.615v9.58h-7.6v-9.58z"
              />
              <path
                d="M61.1 143.598v-1.796l8.7 1.197v1.796m-9.1-3.392v-1.797h8.7v1.797m-8.3-2.595v-1.497l8.7-1.097v1.397m10.5 5.388v1.796l-8.7-1.197v-1.796m8.7-5.588v1.796h-8.7v-1.796m8.7 2.295v1.596l-8.7 1.397v-1.696"
                fill="#F34BED"
                fillRule="nonzero"
              />
              <path
                fill="#FDBAF9"
                fillRule="nonzero"
                d="M312.9 137.51h-27.4v-17.162l13.9-7.185 13.5 7.185"
              />
              <path
                stroke="#FC86F6"
                strokeWidth={2}
                d="M284 121.445l15.4-8.282 15.4 8.282"
              />
              <path
                d="M298.2 120.946v-2.494c0-.6.5-1.098 1.1-1.098.6 0 1.1.499 1.1 1.098v2.494m-10.8 3.094h6.5v7.085h-6.5v-7.085zm12.7 0h6.5v7.085h-6.5v-7.085z"
                fill="#FC86F6"
                fillRule="nonzero"
              />
              <path
                d="M63.4 59.178c-.6.4-49.9.898-49.9 0s6.8-1.397 10.3-2.794c3.5-1.497 7.2-2.495 9.6-1.397 2.4 1.098 5.3 2.495 7.7 1.397 2.4-1.098 4.2-2.794 7.4-2.495 3.2.4 3.2 1.397 5.8 2.495 2.6 1.098 3.2-2.096 4.8-1.397 1.7.599 4.9 3.692 4.3 4.191zM233 57.282c0 .599-68.3 1.397-68.3 0s10.6-1.397 14.5-2.994c3.9-1.596 8.7-2.494 11.7-1.197 3 1.297 11.2 1.996 14.2.699 3-1.298 5.3-3.493 9.3-3.094 4 .4 4 1.796 7.3 3.094 3.3 1.297 4-.4 6 .498 2 .799 5.3 2.395 5.3 2.994z"
                fill="#7F7F7F"
                fillRule="nonzero"
              />
              <path
                d="M259.8 145.693s-20.3-5.288-33-5.288c-12.8 0-75.8 1.596-86.7 1.896-10.9.3-21.8 3.392-21.8 3.392h141.5zM123 156.47s-21.7-3.891-35.3-2.893c-13.6.998-50.5.698-56.6.399-6.1-.3-31.1 2.794-31.1 2.794l123-.3zm90.1 30.735c-10.1-1.497-23.3-.4-41.3-.4-18 0-27.8 1.897-37.1 1.897-9.4 0-16.1 1.497-16.1 1.497h107.3s-2.6-1.497-12.8-2.994z"
                fill="#6A6A6A"
                fillRule="nonzero"
              />
              <path
                fill="#FDBAF9"
                fillRule="nonzero"
                d="M250 132.222h.9v26.045h-.9z"
              />
              <path
                d="M263.7 142.3l-24.5 1.398-.3-6.586 24.5-1.397 3.3 3.093m-24.9-5.189l19.9.599v-6.586l-19.8-.599-3.2 3.293"
                fill="#FFF"
                fillRule="nonzero"
              />
              <path
                d="M243.3 140.205c0 .1.1.3.3.2.2 0 .3-.1.3-.2s0-.2-.3-.2l-.3-.1c-.5-.099-.6-.398-.6-.598 0-.4.3-.599.7-.599.4 0 .7.2.7.6h-.4c0-.1-.1-.2-.3-.2-.2 0-.3.1-.3.2 0 .099 0 .199.2.199l.3.1c.5.1.6.399.6.598 0 .4-.4.599-.7.599-.5 0-.8-.3-.8-.599h.6zm1.3-.1c0-.399.3-.698.7-.798.4 0 .8.3.8.699 0 .399-.3.798-.7.798-.5 0-.8-.3-.8-.699zm1-.1c0-.199-.2-.299-.3-.299-.2 0-.3.1-.3.3 0 .2.2.299.3.299.2.1.3-.1.3-.3zm1.2.7h-.4l-.1-2.196h.4v1.197l.3-.399h.5l-.6.599.7.798h-.5l-.5-.599.2.6zm1-.7c0-.399.3-.698.7-.798.4-.1.8.3.8.699 0 .399-.3.798-.7.798-.5 0-.8-.3-.8-.698zm1.1 0c0-.199-.2-.299-.3-.299-.2 0-.3.1-.3.3 0 .2.2.299.3.299.1 0 .3-.1.3-.3zm1.2-.798l.3-.2v.3l-.3.2v1.097h-.4v-.898l-.3.2v-.3l.3-.2v-.997h.4v.798zm1.1 1.397c-.4 0-.7-.3-.8-.698 0-.4.3-.699.7-.798.4 0 .8.299.8.698.1.499-.3.798-.7.798zm0-.399c.2 0 .3-.1.3-.3 0-.199-.2-.299-.3-.299-.2 0-.3.1-.3.3 0 .2.1.3.3.3zm.1-1.696l-.3.499h.3l.4-.5h-.4zm2.6 2.095h-.4l-.3-.898-.2.898h-.4l-.6-1.397h.5l.3.799.2-.898h.4l.3.798.2-.898h.5l-.5 1.596zm1.4-2.195h.9c.5 0 .7.3.7.699 0 .299-.2.698-.7.698h-.4v.699h-.4l-.1-2.096zm.4.4v.598h.4c.2 0 .3-.2.3-.3 0-.1-.1-.299-.3-.299h-.4zm1.3.997c0-.4.3-.698.7-.798.4 0 .8.3.8.698 0 .4-.3.799-.7.799-.5 0-.8-.3-.8-.699zm1-.1c0-.2-.2-.3-.3-.3-.2 0-.3.1-.3.3 0 .2.2.3.3.3.2.1.4-.1.3-.3zm1.8.699v-.2c-.1.1-.2.2-.4.2-.4 0-.7-.3-.7-.699 0-.499.3-.798.7-.798.2 0 .4.1.4.2v-.998h.4l.1 2.195-.5.1zm-.3-.998c-.2 0-.3.1-.3.3 0 .199.2.299.3.299.2 0 .3-.1.3-.4 0-.1-.2-.299-.3-.2zm1.5-1.198l.1 2.196h-.4l-.1-2.196h.4zm.7 1.697c.1 0 .3.1.3.2s-.1.299-.3.299c-.1 0-.3-.1-.3-.3 0-.1.1-.2.3-.2zm-13.9-10.578h.5l-.8 2.196h-.4l-.3-1.198-.3 1.198h-.4l-.7-2.295h.5l.4 1.397c.1-.4.2-.699.3-1.098h.4l.3 1.098.5-1.298zm1-.1c.2 0 .3.1.3.3 0 .1-.1.3-.3.3-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3zm.2 2.395h-.4v-1.496h.4v1.496zm1.3-1.496v.399h-.3v1.197h-.4v-1.197h-.3v-.4h.3v-.598h.4v.599h.3zm.7 1.496h-.4l.1-2.295h.4v1.198l.4-.4h.6l-.6.7.7.897h-.6l-.5-.598-.1.498z"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                d="M252.1 130.925c0-.499.4-.798.8-.798s.8.299.8.798c0 .499-.4.798-.8.798-.5 0-.8-.3-.8-.798zm1.1 0c0-.2-.1-.3-.3-.4-.2 0-.3.1-.4.3 0 .2.1.4.3.4.3.1.4-.1.4-.3zm2.5.898h-.4l-.3-.998-.3.998h-.4l-.5-1.497h.5l.2.898.3-.898h.4l.2.898.3-.898h.5l-.5 1.497zm.6-.798c0-.5.4-.799.8-.799s.8.3.8.799c0 .499-.4.798-.8.798s-.8-.3-.8-.798zm1.2 0c0-.2-.1-.3-.3-.4-.2 0-.3.1-.4.3 0 .2.1.4.3.4.2.099.4 0 .4-.3zM56.3 116.057h49.9v1.496H56.3v-1.496zm167.2.698h-41.8v-2.395l41.8 1.896m-40.2-15.167h-33.4v-.699l16.7-2.594 16.7 2.594"
                fill="#FDBAF9"
                fillRule="nonzero"
              />
              <path
                d="M78.5 6.59h8.7c1.3 0 2.3-.998 2.3-2.295S88.5 2 87.2 2h-8.7c-1.3 0-2.3.998-2.3 2.295 0 1.198 1 2.295 2.3 2.295z"
                fill="#00D861"
                fillRule="nonzero"
              />
              <path
                d="M33.9 6.59h34.3c1.3 0 2.3-.998 2.3-2.295S69.5 2 68.2 2H33.9c-1.3 0-2.3.998-2.3 2.295 0 1.198 1 2.295 2.3 2.295z"
                fill="#FC86F6"
                fillRule="nonzero"
              />
              <path
                d="M19.5 6.59h4.1c1.3 0 2.3-.998 2.3-2.295S24.9 2 23.6 2h-4.1c-1.3 0-2.3.998-2.3 2.295 0 1.198 1 2.295 2.3 2.295zM140 74.246h29.7c1.3 0 2.3-.998 2.3-2.295s-1-2.295-2.3-2.295H140c-1.3 0-2.3.998-2.3 2.295 0 1.197 1.1 2.295 2.3 2.295z"
                fill="#0E65E5"
                fillRule="nonzero"
              />
              <path
                d="M104 74.246h15.3c1.3 0 2.3-.998 2.3-2.295s-1-2.295-2.3-2.295H104c-1.3 0-2.3.998-2.3 2.295 0 1.197 1.1 2.295 2.3 2.295z"
                fill="#18E5EF"
                fillRule="nonzero"
              />
              <ellipse
                fill="#1ED760"
                fillRule="nonzero"
                cx={129.7}
                cy={71.851}
                rx={2.3}
                ry={2.295}
              />
              <path
                d="M220.1 184.41h15.3c1.3 0 2.3-.997 2.3-2.294 0-1.297-1-2.295-2.3-2.295h-15.3c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295z"
                fill="#FC86F6"
                fillRule="nonzero"
              />
              <ellipse
                fill="#0E65E5"
                fillRule="nonzero"
                cx={209.8}
                cy={182.116}
                rx={2.3}
                ry={2.295}
              />
              <path
                d="M260.1 184.41h34.3c1.3 0 2.3-.997 2.3-2.294 0-1.297-1-2.295-2.3-2.295h-34.3c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295z"
                fill="#093272"
                fillRule="nonzero"
              />
              <path
                d="M245.7 184.41h4.1c1.3 0 2.3-.997 2.3-2.294 0-1.297-1-2.295-2.3-2.295h-4.1c-1.3 0-2.3.998-2.3 2.295s1.1 2.295 2.3 2.295z"
                fill="#00D861"
                fillRule="nonzero"
              />
              <path
                d="M256.5 37.724h-8.7c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295h8.7c1.3 0 2.3-.998 2.3-2.295s-1-2.295-2.3-2.295z"
                fill="#0E65E5"
                fillRule="nonzero"
              />
              <path
                d="M289.8 37.724h-23c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295h23c1.3 0 2.3-.998 2.3-2.295s-1-2.295-2.3-2.295z"
                fill="#1ED760"
                fillRule="nonzero"
              />
              <path
                d="M304.2 37.724h-4.1c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295h4.1c1.3 0 2.3-.998 2.3-2.295s-1.1-2.295-2.3-2.295zM77 168.445h-8.7c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295H77c1.3 0 2.3-.998 2.3-2.295 0-1.197-1-2.295-2.3-2.295z"
                fill="#093272"
                fillRule="nonzero"
              />
              <path
                d="M110.3 168.445h-23c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295h23c1.3 0 2.3-.998 2.3-2.295 0-1.197-1.1-2.295-2.3-2.295z"
                fill="#0E65E5"
                fillRule="nonzero"
              />
              <path
                d="M124.7 168.445h-4.1c-1.3 0-2.3.998-2.3 2.295s1 2.295 2.3 2.295h4.1c1.3 0 2.3-.998 2.3-2.295 0-1.197-1.1-2.295-2.3-2.295z"
                fill="#00D861"
                fillRule="nonzero"
              />
            </g>
          </svg>
        )}
      </div>
    </SNotFound>
  )
}

export default NotFound
